import { render } from "./Tab3.vue?vue&type=template&id=3acabd1c&scoped=true"
import script from "./Tab3.vue?vue&type=script&lang=js"
export * from "./Tab3.vue?vue&type=script&lang=js"

import "./Tab3.vue?vue&type=style&index=0&id=3acabd1c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acabd1c"]])

export default __exports__